import { render, staticRenderFns } from "./ConfirmationRegistr.vue?vue&type=template&id=02598278&scoped=true&"
import script from "./ConfirmationRegistr.vue?vue&type=script&lang=js&"
export * from "./ConfirmationRegistr.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationRegistr.vue?vue&type=style&index=0&id=02598278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02598278",
  null
  
)

export default component.exports